import React from 'react';
import SvgIcon from './SvgIcon';

const Event = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M19.95 19.95A11.25 11.25 0 1121.525 6m-5.25 10.275a6.075 6.075 0 11.15-8.4"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM21 14.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM13.124 13.125l6.825 6.825"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Event.displayName = 'EventIcon';

export default Event;
